<template>
    <div>

        <v-row>
            <v-col cols="3" class="ml-4">
                <v-text-field clearable label="Search Products" outlined hide-details v-model="search" @input="onSearch"/>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="products" :server-items-length="productAggregate.count" :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc" :footer-props="{itemsPerPageOptions:rowsPerPageItems}" fixed-header height="calc(100vh - 284px)"
                      :options.sync="options" @update:options="onUpdateOptions" :loading="loading" @update:page="$vuetify.goTo(0)">
            <template v-slot:no-data>No Products Available</template>
            <template v-slot:no-results>No Products Available</template>
            <template v-slot:item.name="{ item }">
                <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(item.Attachments)" title="View Image">
                    <v-img v-if="item.Attachments.length" :src="imgWpx(item.Attachments[0].path, 200)" alt="image">
                        <template v-slot:placeholder>
                            <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                            <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                        </template>
                    </v-img>
                </v-avatar>
                <span class="ellipsis product-name">
                            <span :title="item.name">{{ item.name}}</span><br>
                            <span :title="item.sku" class="f-12 grey--text text--darken-1">{{item.sku}}</span>
            </span>
            </template>
            <template v-slot:item.StockAvailable="{ item }">{{ item.aggregate.sum.StockAvailable}}</template>
            <template v-slot:item.purchasePrice="{ item }">{{ item.purchasePrice | currencyFilter}}</template>
            <template v-slot:item.displayPrice="{ item }">{{ item.displayPrice | currencyFilter}}</template>
            <template v-slot:item.margin="{ item }">{{ item.margin | currencyFilter}}</template>
            <template v-slot:item.profitPercentage="{ item }">{{profitPercentage(item.purchasePrice, item.displayPrice) }} %</template>
            <template v-slot:item.action="{ item }">
                <v-btn icon title="Edit Product" @click.stop="onEditProduct(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
            </template>
            <template slot="body.append" v-if="products.length&&productAggregate.avg">
                <tr style="color: teal; font-weight: bolder">
                    <td>Summary</td>
                    <td class="text-end">{{roundOffValue(productAggregate.avg.StockAvailable)}}</td>
                    <td class="text-end">{{productAggregate.avg.purchasePrice | currencyFilter}}</td>
                    <td class="text-end">{{productAggregate.avg.displayPrice | currencyFilter}}</td>
                    <td class="text-end">{{productAggregate.avg.margin | currencyFilter}}</td>
                    <td class="text-end">-</td>
                </tr>
            </template>
        </v-data-table>

        <purchase-product-form :dialog.sync="formDialog" :id.sync="productId"/>
        <gallery id="gallery-purchase-new-products" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
    </div>
</template>

<script>
    import {
        purchase_new_products_aggregate,
        purchase_new_products_aggregate_summary,
        purchase_new_products_statement,
    } from "../../graphql/customStatement";
    import Constants from "../../Constants/Constants";
    import moment from 'moment';
    import {SUBSCRIBE_PURCHASE_NEW_PRODUCTS, SUBSCRIBE_PURCHASE_NEW_PRODUCTS_COUNT} from "../../graphql/subscriptions/Products";
    import gallery from '../../mixins/gallery';
    import {profitPercentage, roundOffValue} from "../../util/helpers";
    import {debounce} from "lodash";
    import PurchaseProductForm from "./PurchaseProductForm";
    let options= {page: 1, itemsPerPage: 25, offset:0, limit:25};
    export default {
        name: "NewProducts",
        components: {PurchaseProductForm},
        mixins: [gallery],
        apollo:{
            $subscribe:{
                productCount: {
                    query: SUBSCRIBE_PURCHASE_NEW_PRODUCTS_COUNT,
                    variables() { return {
                        statement: purchase_new_products_statement('', this.prepareSearchString(this.productSearch)),
                        aggregate: purchase_new_products_aggregate_summary,
                    }},
                    result({data}) { /*console.log('summary', data.productCount);*/
                                     this.productAggregate = data.productCount[0]?.aggregate||{count: 0}; }
                },
                products: {
                    query: SUBSCRIBE_PURCHASE_NEW_PRODUCTS,
                    variables() { return {
                        statement: purchase_new_products_statement(this.prepareSortString(this.sortBy, this.sortDesc), this.prepareSearchString(this.productSearch)),
                        aggregate: purchase_new_products_aggregate,
                        offset: this.options.offset, limit: this.options.limit
                    }},
                    result({data}) { this.products = data.products; this.loading = false; }
                },
            }
        },
        data () {
            return {
                Constants: Constants,
                moment: moment,
                loggedInUser: JSON.parse(localStorage.user),
                search: '', productSearch: '',
                headers: [
                    { text: 'PRODUCT NAME', value: 'name', width:370 },
                    { text: 'CURRENT STOCK', value: 'StockAvailable', align:'end' },
                    { text: 'PURCHASE PRICE', value: 'purchasePrice', align:'end' },
                    { text: 'SELLING PRICE', value: 'displayPrice', align:'end' },
                    { text: 'PROFIT AMOUNT', value: 'margin', align:'end' },
                    { text: 'PROFIT %', value: 'profitPercentage', align:'end', sortable:false },
                    { text: 'ACTION', value: 'action', align:'end' },
                ],
                products: [], productAggregate: {count:25},
                options: options, loading: true,
                offset: 0, limit: 25, itemsPerPage: 25, rowsPerPageItems: [25, 50, 100, -1],
                sortBy: ['name'], sortDesc: [false],
                profitPercentage, roundOffValue,
                formDialog: false,
                productId: null
            }
        },
        methods:{
            prepareSortString([sortBy], [order]){
                order = order?'desc':'asc'
                if(['name', 'purchasePrice', 'displayPrice', 'margin'].includes(sortBy)) return `order by p."${sortBy}" ${order}`
                if(['StockAvailable'].includes(sortBy)) return `order by ${sortBy}  ${order}`
                if(sortBy === 'profitPercentage') return `order by ((p."displayPrice" - p."purchasePrice")/p."purchasePrice") ${order}`
                return ''
            },
            prepareSearchORExp(search){
               /* let arr = [] */
                if(search){
                   /* search.split(' ').forEach(word => { if(word) arr.push({name: {_ilike: '%'+word+'%'}}) })
                    return [...arr, {sku: {_ilike: '%'+search+'%'}}] */
                    return [{name: {_ilike: '%'+search+'%'}}, {sku: {_ilike: '%'+search+'%'}}]
                }
                return {}
            },
            prepareSearchString(search){
                if(search) return `AND (name ilike '%${search}%' OR sku ilike '%${search}%')`;
                return '';
            },
            onEditProduct(row){
                this.productId = row.id;
                this.formDialog = true;
            },
            onUpdateOptions(val){
                if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                    this.options.limit = this.productCount          //assign total count
                    this.options.offset = 0
                }else{
                    this.options.limit = val.itemsPerPage
                    this.options.offset = (val.page -1) * val.itemsPerPage;
                }
            },
            onSearch: debounce(function(val){
                this.productSearch = val
                this.options = options          //on search, reset page options
            }, 500),
        }
    }
</script>

<style scoped>
    .avatar{
        cursor: pointer;
    }
    .ellipsis{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: default;
    }
    .product-name {
        display: inline-block;
        vertical-align: middle;
        width: 250px;
        max-width: 250px;
    }
</style>